/// <reference path='./global.d.ts' />

import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import { Locales, ScrollTop, Snackbar } from 'components'

import Routes from 'routes'
import ThemeCustomization from 'themes'

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App = () => {
  const location = useLocation()

  useEffect(() => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'page-view',
    })
  }, [location])

  return (
    <ThemeCustomization>
      {!process.env.REACT_APP_ROOT_DOMAIN && (
        <ReactQueryDevtools initialIsOpen />
      )}
      <Locales>
        <ScrollTop>
          <>
            <Routes />
            <Snackbar />
          </>
        </ScrollTop>
      </Locales>
    </ThemeCustomization>
  )
}

export default App
